import React from "react";

export const CustomDropdownToggle = React.forwardRef(
  ({ children, onClick, containerClass, containerStyle }, ref) => {
    return (
      <div
        className={containerClass ?? "tw-inline-block no-copy"}
        style={containerStyle}
        ref={ref}
        onClick={(e) => {
          e.preventDefault();
          onClick(e);
        }}
      >
        {children}
      </div>
    );
  }
);
